import { render, staticRenderFns } from "./finalizeSoRegisteration.vue?vue&type=template&id=4cc46b2b"
import script from "./finalizeSoRegisteration.vue?vue&type=script&lang=js"
export * from "./finalizeSoRegisteration.vue?vue&type=script&lang=js"
import style0 from "./finalizeSoRegisteration.vue?vue&type=style&index=0&id=4cc46b2b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports